import { Cell } from 'react-table'
import { ReactComponent as VerifiedIcon } from 'images/verified.svg'
import { LanguageOutlined, AlternateEmail, Home } from '@material-ui/icons'
import { Grid, Tooltip, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import cn from 'classnames'
import format from 'civic-champs-shared/utils/format'
import { ColoredIcon } from 'core/table/cells/modern'

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#000',
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)',
    borderRadius: '5px',
    border: '1px #E0E3E3 solid',
    padding: '8px',
  },
  tooltipHeader: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: '#000000',
  },
  arrow: {
    color: '#fff',
  },
  cellGrid: { fontSize: '20px', width: '100px' },
  verifiedBlock: {
    width: '100%',
    whiteSpace: 'nowrap',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  verifiedIcon: {
    color: '#0F5DB5',
    marginLeft: '4px',
    flexShrink: 0,
    '&$doNotContact': {
      color: theme.palette.error.main,
    },
  },
  link: {
    color: '#0F5DB5',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  websiteIcon: {
    fontSize: 'inherit',
    color: '#0F5DB5',
    cursor: 'pointer',
    verticalAlign: 'middle',
  },
}))

const withProtocol = (url?: string) => {
  if (!url) return ''
  return /^(https?:)?\/\//i.test(url) ? url : `https://${url}`
}

export const ContactTooltip = ({ value, children }: any) => {
  const { email, website, address } = value
  const classes = useStyles()

  if (!email && !address && !website) {
    return null
  }

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      title={
        <>
          {(email || website || address) && (
            <>
              <Typography className={classes.tooltipHeader}>Contact Information</Typography>
              <Grid container spacing={0}>
                {email && (
                  <Grid item xs={12}>
                    <div className={cn(classes.verifiedBlock)}>
                      {email} <VerifiedIcon className={cn(classes.verifiedIcon)} />
                    </div>
                  </Grid>
                )}
                {address && (
                  <>
                    <Grid item xs={4}>
                      Address:
                    </Grid>
                    <Grid item xs={7}>
                      {format.address(address)}
                    </Grid>
                  </>
                )}
                {website && (
                  <>
                    <Grid item xs={4}>
                      Website:
                    </Grid>
                    <Grid item xs={7}>
                      <a
                        href={withProtocol(website)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.link}
                      >
                        {website} <LanguageOutlined className={classes.websiteIcon} />
                      </a>
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          )}
        </>
      }
      placement="right-start"
      arrow
      interactive
    >
      {children}
    </Tooltip>
  )
}

export const OrganizationContactCell = ({ value }: Cell<any>) => {
  const classes = useStyles()
  const { email, address, website } = value

  return (
    <ContactTooltip value={value}>
      <Grid container className={classes.cellGrid} justify="space-between">
        <Grid item>
          <ColoredIcon Component={AlternateEmail} verified display={!!email} />
        </Grid>
        <Grid item>
          <ColoredIcon Component={Home} verified display={!!address} />
        </Grid>
        <Grid item>
          <ColoredIcon Component={LanguageOutlined} verified display={!!website} />
        </Grid>
      </Grid>
    </ContactTooltip>
  )
}
